import { render, staticRenderFns } from "./SimpleUploader.vue?vue&type=template&id=ba635ff4"
import script from "./SimpleUploader.vue?vue&type=script&lang=ts"
export * from "./SimpleUploader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports